import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'centsToMajorUnit',
})
export class CentsToMajorUnitPipe implements PipeTransform {
    transform(value): number {
        const floatValue = parseFloat(value);

        const decimalValue = floatValue && floatValue !== NaN ? floatValue : 0;

        return Math.round(decimalValue) / 100;
    }
}
